import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICountryDtoModel } from "../models/country/country-dto.model";
import { ICustomerOptions } from "../models/customer/customer-options.model";
import { ApplicationContextService } from "./application-context.service";
import { EnvironmentService } from "./environment.service";
import { ITaxonomyDtoModels } from "../models/taxonomy/taxonomy-dto.model";
import { IProductBranchStatusesModel } from "../models/product/dto/pricing/product-branch-statuses.model";

@Injectable({
    providedIn: 'root'
  })
export class OptionService {
    fullPath:any;
    constructor(private httpClient: HttpClient,
        private envService: EnvironmentService,
        private applicationContext: ApplicationContextService) {
            this.fullPath = `${envService?.settings?.apiUrl}`;
    }
    public getOptions(): Observable<ICustomerOptions> {
        return this.httpClient.get<ICustomerOptions>(`${this.fullPath}/Options${this.applicationContext.isApplicationEmbedded() ? '?branchCode=' + this.applicationContext.getBranchCodeFromUrl() : ''}`);
    }

    public getCountries(): Observable<ICountryDtoModel[]> {
        return this.httpClient.get<ICountryDtoModel[]>(`${this.fullPath}/Options/countries`);
    }

    public getBranchProductStatuses(productId?:string): Observable<IProductBranchStatusesModel> {
        return this.httpClient.get<IProductBranchStatusesModel>(`${this.fullPath}/Options/branchProductStatuses${productId ? '?productId=' + productId : ''}`);
    }

    public getTaxonomies(parentCode: string): Observable<ITaxonomyDtoModels> {
        return this.httpClient.get<ITaxonomyDtoModels>(
          `${this.fullPath}/Options/taxonomy?parentCode=${parentCode}`
        ); 
      }
}